export default {
    ABERTO: 'Aberto',
    RANDOMICO: 'Randômico',
    ABERTO_FECHADO: 'Aberto/Fechado',
    FECHADO: 'Fechado',
    FECHADO_ABERTO: 'Fechado/Aberto'
}
